import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from 'react';
import { usePreferencesStore } from '../hooks/usePreferenceStore.web.js';
const PreferenceContext = createContext(null);
export function PreferenceProvider({ children }) {
    const store = usePreferencesStore();
    return _jsx(PreferenceContext.Provider, { value: store, children: children });
}
export function usePreferences() {
    const ctx = useContext(PreferenceContext);
    if (!ctx) {
        throw new Error('usePreferences must be used within PreferenceProvider');
    }
    return ctx;
}
//# sourceMappingURL=PreferenceProvider.js.map